import React from 'react';
import PropTypes from 'prop-types';
import {Radio as MRadio, FormControlLabel} from '@mui/material';
import {Typography} from '@mui/material';
import {Box} from '@mui/system';

const RadioCard = (props) => {
  const isSelected = props.selected;
  const value = props.value;
  const disabled = props.disabled;
  const label = props.label;
  const children = props.children;

  return (
    <Box
      sx={{
        border: 1,
        borderColor: (isSelected)? 'primary.dark' : 'grey.500',
        backgroundColor: (isSelected)? 'primary.light' : 'grey.100',
        width: '100%',
        height: '100%',
        px: 2,
        py: 1,
      }}
    >
      <FormControlLabel
        value={value}
        disabled={disabled}
        control={<MRadio />}
        label={label}
        labelPlacement="end"
      />
      <Typography variant="body2" color="text.secondary">
        {children}
      </Typography>
    </Box>
  );
};

RadioCard.propTypes = {
  value: PropTypes.any,
  selected: PropTypes.bool,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.any,
};

export default React.memo(RadioCard);
